<template>
    <div class="login career-login">
        <div class="center-stage">
            <div class="login-shell">
        <section class="left-panel">
            <div class="left-top">
                <a class="brand-link" href="/">
                    <img class="brand-icon" src="../../assets/kairan.png" alt="CareerCompass logo" />
                    <span>神二科技</span>
                </a>
            </div>
            <div class="characters-wrap">
                <AnimatedCharacters
                    :is-typing="isTyping"
                    :show-password="showPassword"
                    :password-length="(loginForm.pwd || '').length"
                />
            </div>
            <div class="left-links">
                <!-- <a href="/privacy-policy">Privacy Policy</a>
                <a href="/terms">Terms of Service</a> -->
            </div>
            <div class="grid-mask"></div>
            <div class="glow glow-top"></div>
            <div class="glow glow-bottom"></div>
        </section>
        <section class="right-panel">
            <div class="form-box">
                <div class="mobile-brand">
                    <img class="brand-icon mobile-icon" src="https://i.postimg.cc/nLrDYrHW/icon.png" alt="CareerCompass logo" />
                    <span>CareerCompass</span>
                </div>
                <div class="form-head">
                    <h1>神二科技</h1>
                    <p>物联网通信服务平台</p>
                </div>
                <el-form ref="loginForm" :model="loginForm" :rules="loginRules" class="login-wrap">
                    <div class="form-item account-wrap">
                        <span class="input-label">登录账号</span>
                        <el-input
                            size="medium"
                            placeholder="请输入登录账号"
                            v-model.trim="loginForm.accountName"
                            autocomplete="off"
                            @focus="isTyping = true"
                            @blur="isTyping = false"
                            @keyup.enter.native="handleLogin"
                        />
                        <div class="showRememberAccount" v-if="showAccountsPanel">
                            <RememberAccount @func="getAccountFormSon"></RememberAccount>
                        </div>
                    </div>
                    <div class="form-item">
                        <span class="input-label">登录密码</span>
                        <el-input
                            size="medium"
                            :type="showPassword ? 'text' : 'password'"
                            autocomplete="off"
                            placeholder="请输入登录密码"
                            v-model.trim="loginForm.pwd"
                            @focus="isTyping = true"
                            @blur="isTyping = false"
                            @keyup.enter.native="handleLogin"
                        >
                            <i slot="suffix" class="el-icon-view password-toggle" @click="showPassword = !showPassword"></i>
                        </el-input>
                    </div>
                    <div class="option-line">
                        <el-checkbox v-model="rememberMe">记住密码</el-checkbox>
                        <el-link type="primary" :underline="false" @click="findPass();return false;">忘记密码</el-link>
                    </div>
                    <button class="hover-btn btn-primary" type="button" @click.prevent="handleLogin">
                        <span class="btn-text">登 录</span>
                        <span class="btn-overlay">开工啦，电量满格✨ <i class="el-icon-right"></i></span>
                    </button>
                </el-form>
            </div>
        </section>
            </div>
        </div>
        <el-dialog title="忘记密码" :visible.sync="findPassWold" width="600px" :show-close="false">
            <p style="color: #fd5353; text-align: center; margin-bottom: 20px;">{{modifyPwdTip}}</p>
            <el-form ref="modifyPwdForm" :model="modifyPwdForm" :rules="pwdRules" label-width="100px">
                <el-form-item label="账号：">
                    <el-input v-model.trim="modifyPwdForm.oldPwd" placeholder="请输入平台账号" clearable></el-input>
                </el-form-item>
                <el-form-item label="手机号：">
                    <el-input v-model.trim="modifyPwdForm.userPhone" placeholder="请输入实名认证手机号" clearable></el-input>
                </el-form-item>
                <el-form-item label="验证码：">
                    <el-input style="width:30%" v-model.trim="modifyPwdForm.code" clearable></el-input>
                    <el-button class="codeBtn" type="primary" @click="sendCode()">发送验证码</el-button>
                </el-form-item>
                <el-form-item label="新密码：" prop="newPwd">
                    <el-input v-model.trim="modifyPwdForm.newPwd" show-password clearable></el-input>
                </el-form-item>
                <el-form-item label="确认密码：" prop="newPwdAgain">
                    <el-input v-model.trim="modifyPwdForm.newPwdAgain" show-password clearable @keyup.native.enter="modifyPwd()"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="cancel">取消</el-button>
                <el-button type="primary" @click="modifyPwd12">确定</el-button>
            </div>
        </el-dialog>
        <el-dialog title="修改密码" :visible.sync="modifyPwdVisible" width="600px" :show-close="false">
            <p style="color: #fd5353; text-align: center; margin-bottom: 20px;">{{modifyPwdTip}}</p>
            <el-form ref="modifyPwdForm" :model="modifyPwdForm" :rules="pwdRules" label-width="100px">
                <el-form-item label="原密码：">
                    <el-input v-model.trim="modifyPwdForm.oldPwd" show-password></el-input>
                </el-form-item>
                <el-form-item label="新密码：" prop="newPwd">
                    <el-input v-model.trim="modifyPwdForm.newPwd" show-password></el-input>
                </el-form-item>
                <el-form-item label="确认密码：" prop="newPwdAgain">
                    <el-input v-model.trim="modifyPwdForm.newPwdAgain" show-password></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="cancel">取消</el-button>
                <el-button type="primary" @click="modifyPwd">确定</el-button>
            </div>
        </el-dialog>
        <el-dialog title="实名认证通知" :visible.sync="auth.isAuth" width="600px" :show-close="false">
            <p style="color: red">1. 为保障代理商权益并防止违法违规行为，所有代理商需完成实名认证后方可进入后台。</p><br/>
            <p style="color: red">2. 您提交的资料仅用于实名认证审核，我们会依法合规保护您的隐私信息。</p><br/>
            <p style="color: red">3. 请确保姓名、身份证号、手机号信息一致，并在提交前仔细核对。</p>
            <p style="color: #fd5353; text-align: center; margin-bottom: 20px;">{{modifyPwdTip}}</p>
            <el-form ref="modifyPwdForm" :model="auth" label-width="100px">
                <el-form-item label="姓名：" prop="nickname">
                    <el-input v-model.trim="auth.nickname" placeholder="请输入真实姓名"></el-input>
                </el-form-item>
                <el-form-item label="手机号：" prop="phone">
                    <el-input v-model.trim="auth.phone" placeholder="用于找回密码、绑定收款等"></el-input>
                </el-form-item>
                <el-form-item label="身份证号：" prop="cardCode">
                    <el-input v-model.trim="auth.cardCode" placeholder="请输入身份证号码"></el-input>
                </el-form-item>
                <el-form-item label="身份证正面照：">
                    <input type="file" ref="file1">
                    <div v-if="!existBackImg"></div>
                    <img v-else :src="frontImgUrl" alt="" width="150" height="150">
                </el-form-item>
                <el-form-item label="身份证反面照：">
                    <input type="file" ref="file2">
                    <div v-if="!existBackImg"></div>
                    <img v-else :src="backImgUrl" alt="" width="150" height="150">
                </el-form-item>
                <el-form-item label="状态：">
                    <el-input v-model.trim="auth.stateName" disabled="disabled"></el-input>
                </el-form-item>
                <el-form-item label="审核备注：">
                    <el-input v-model.trim="auth.remark" disabled="disabled"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="cancel2">取消</el-button>
                <el-button type="primary" @click="agentAuth">确定</el-button>
            </div>
        </el-dialog>
        <el-dialog title="实名认证通知" :visible.sync="istoAuth" width="600px" :show-close="false">
            <p>尊敬的代理商：为保障平台安全与合规运营，现要求所有合作代理商完成实名认证后再进行业务操作。</p><br/>
            <p>1. 实名认证信息需真实、完整，姓名、身份证号、手机号须保持一致。</p><br/>
            <p>2. 请勿冒用他人信息进行认证，若存在违规行为，平台将依法追责。</p><br/>
            <p>3. 后续如发生账号纠纷，以实名认证信息作为账户归属依据。</p><br/>
            <p>4. 请规范管理下级合作渠道，发现风险行为请及时终止合作。</p><br/>
            <p>5. 若出现违法、违规、诈骗或被投诉举报等情况，相关责任由实名主体承担。</p><br/>
            <p>6. 平台将依法配合监管及公安机关提供必要的实名认证信息。</p><br/>
            <div slot="footer" class="dialog-footer">
                <el-button @click="cancel1">取消</el-button>
                <el-button type="primary" @click="istoAuthName">同意</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import {login} from '@/api/user.js'
import {sysRequest} from '@/api/customizedRequest.js'
import { mapActions } from "vuex";

import RememberAccount from '@/component/RememberAccount'
import AnimatedCharacters from './AnimatedCharacters.vue'
export default {
    components: { RememberAccount, AnimatedCharacters },
    name: 'login',
    data(){
        var checkNewPwd = (rule, value, callback) => {
            if(value.length > 16 || value.length < 6){
                return callback(new Error('请输入 6 ~ 16 位密码'))
            }
            callback();
        };
        var checkPwd = (rule, value, callback) => {
            if(value != this.modifyPwdForm.newPwd){
                return callback(new Error('两次输入密码不一致'))
            }
            callback();
        };
        return {
            disabled:false,
            isTyping:false,
            showPassword:false,
            findPassWold:false,
            loginForm: {
                accountName: '',
                pwd: ''
            },
            loginRules: {
                accountName: [
                    {required: true, message: '请输入用户名', trigger: 'blur'}
                ],
                pwd: [
                    {required: true, message: '请输入密码', trigger: 'blur'}
                ]
            },

             existBackImg: false,
            auth:{
                isAuth:false,
                nickname:'',
                phone:'',
                cardCode:'',
                stateName:'',
                remark:''
            },
             verifiedSrcList:[],
            rememberMe:false,
            backImgUrl:'',
            frontImgUrl:'',
            handImgUrl:'',
            istoAuth:false,

            // 修改密码
            modifyPwdVisible:false,
            modifyPwdTip:'',
            modifyPwdForm: {
                id: '',
                oldPwd: '',
                newPwd: '',
                newPwdAgain: '',
                code:'',
                userPhone:''
            },
            pwdRules: {
                newPwd: [
                    {validator: checkNewPwd, trigger: 'blur'}
                ],
                newPwdAgain: [
                    {validator: checkPwd, trigger: 'blur'}
                ]
            },

            qrCodeUrl:window.location+'assets/alipay.png',
        }
    },
    methods: {
        findPass(){
            this.findPassWold=true;
        },
         // 修改密码
        modifyPwd12(){
            this.$refs.modifyPwdForm.validate(valid => {
                if(valid) {
                    sysRequest('mould/updatePwd/phone', this.modifyPwdForm, 'post').then(res => {
                        var code = res.data.code;
                        if(code == 200){
                            for(var key in this.modifyPwdForm){
                                this.modifyPwdForm[key] = '';
                            }
                            this.$refs['modifyPwdForm'].resetFields();
                            this.modifyPwdVisible = false;
                            this.findPassWold = false;
                            this.$message.success("修改成功");
                        } else{
                            this.$message.error(res.data.message);
                        }
                    });
                }
            })
        },
        sendCode(){
            var data={
                userPhone:this.modifyPwdForm.userPhone
            }
            sysRequest('mould/sms/code', data, 'post').then(res => {
                var code = res.data.code;
                if(code == 200){
                    this.$message.success('发送成功！');
                }else{
                    this.$message.error(res.data.message);
                }
            });
        },
        agentAuth(){
            //var data =  JSON.parse(JSON.stringify(this.auth));
            var data= new FormData();
            console.log(this.$refs.file1)
            data.append('backUrl',this.$refs.file1.files[0]);
            data.append('frontUrl',this.$refs.file2.files[0]);
            data.append('nickname',this.auth.nickname);
            data.append('phone',this.auth.phone);
            data.append('cardCode',this.auth.cardCode);
            sysRequest('authNickname/agent/insert', data, 'post').then(res => {
                var code = res.data.code;
                if(code == 200){
                    this.$message.success('审核中，可正常登录后台！');
                    this.auth.isAuth=false;
                    this.istoAuth=false;
                }else{
                    this.$message.error(res.data.message);
                }
            });
        },
        ...mapActions("menu", {  setNickName: "setNickName",  setBtns:"setBtns"  }),
        goIntroduction(){
            window.location.href='https://beian.miit.gov.cn/'
        },
        getAccountFormSon(data){
            if(data.account.length > 0){
                this.loginForm.accountName = data.account;
                this.loginForm.pwd = data.password;
            }
        },
        istoAuthName(){
            var dar={'iccid':''}
            sysRequest('authNickname/agent/list/my',dar, 'post').then(res => {
                var code = res.data.code;
                if(code == 200){
                    this.auth.nickname=res.data.data.nickname;
                    this.auth.phone=res.data.data.phone;
                    this.auth.cardCode=res.data.data.cardCode;
                    this.auth.stateName=res.data.data.stateName;
                    this.auth.remark=res.data.data.remark;
                    this.existBackImg=true;
                    this.frontImgUrl = process.env.VUE_APP_IMG_URL + '/' + res.data.data.headerUrl
                    this.backImgUrl = process.env.VUE_APP_IMG_URL + '/' + res.data.data.backHeaderUrl
                    this.handImgUrl = process.env.VUE_APP_IMG_URL + '/' + res.data.data.handheldUrls
                }
            });
            this.auth.isAuth=true;
        },
        handleLogin(){
            this.$refs.loginForm.validate(valid => {
                if(valid){      
                    login(this.loginForm).then(res => {           
                        if(res.data.code == 200||res.data.code == 401){
                            localStorage.setItem('token', res.data.data.token);
                            localStorage.setItem('id', res.data.data.id);
                            localStorage.setItem('agentId', res.data.data.agentId);
                           // 判断是否已实名认证
                            if(res.data.data.isAuth==1){ // 已实名认证
                              this.$store.commit('menu/setToken', res.data.data.token);
                              this.$store.commit('menu/setId', res.data.data.id);
                              var nickName = res.data.data.nickName;
                              this.setNickName(nickName);
                              this.setBtns(res.data.data.actionCodes);
                              this.$router.push('AdminHome');
                              if(this.rememberMe){
                                this.setAutoCompleteData("loginAccounts", this.loginForm.accountName+'/'+this.loginForm.pwd, 8);
                              }
                            }else{
                            this.istoAuthName();
                           }
                        }
                        // else if(res.data.code == 410){
                        //     let token = res.data.data.token;
                        //     let id = res.data.data.id;
                        //     localStorage.setItem('token', token);
                        //     this.modifyPwdForm.id = id;
                        //     this.modifyPwdTip = res.data.message;
                        //     this.modifyPwdVisible = true;
                        // }
                        else if(res.data.code == 400){
                            this.$message.error(res.data.message)
                        }
                    })
                }else{
                    return;
                }
            })
        },

        // 修改密码
        modifyPwd(){
            this.$refs.modifyPwdForm.validate(valid => {
                if(valid) {
                    sysRequest('sysUser/updatePwd', this.modifyPwdForm, 'post').then(res => {
                        var code = res.data.code;
                        if(code == 200){
                            let s = '<span style="color: #fd5353;">为保证账户安全，请勿泄露账号和密码。</span>'
                            this.$alert('修改密码成功！' + s, '提示', 
                                { confirmButtonText: '确定', 
                                dangerouslyUseHTMLString: true, 
                                callback: action => {
                                    window.location.href = window.location;
                                }
                            });
                        }
                        else{
                            this.$message.error(res.data.message);
                        }
                    });
                                               
                }
            })
        },

        cancel(){
            for(var key in this.modifyPwdForm){
                this.modifyPwdForm[key] = '';
            }
            this.$refs['modifyPwdForm'].resetFields();
            this.modifyPwdVisible = false;
             this.findPassWold = false;
        },
         cancel1(){
            this.istoAuth = false;
        },
         cancel2(){
            this.auth.isAuth = false;
        },
    },

    computed: {
        showAccountsPanel: function () {
            let account = this.getAutoCompleteData('loginAccounts');
            if(account!=null && account!=undefined && account.length > 0){
                if(this.loginForm.accountName.length > 0){
                    return false;
                }else{
                    return true;
                }
            }else{
                return false;
            }
        }
    },

    created(){
        
    },

    mounted () {


    }
}
</script>

<style lang="less" scoped>
.career-login {
    min-height: 100vh;
    padding: 22px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: center;
    background: url("../../assets/logo/lg_bj.jpg") no-repeat center center;
    background-size: cover;
}

.center-stage {
    width: 100%;
    max-width: 1320px;
    height: calc(100vh - 44px);
    max-height: 780px;
    border-radius: 24px;
    overflow: hidden;
    box-shadow: 0 28px 80px rgba(4, 17, 43, 0.45);
    background: rgba(255, 255, 255, 0.12);
    backdrop-filter: blur(2px);
}

.login-shell {
    width: 100%;
    height: 100%;
    display: grid;
    grid-template-columns: 1fr 1fr;
}
.left-panel {
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    padding: 48px;
    color: #fff;
    background: linear-gradient(135deg, #9ca3af 0%, #6b7280 50%, #4b5563 100%);
}
.left-top,
.characters-wrap,
.left-links {
    position: relative;
    z-index: 2;
}
.brand-link {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    color: #fff;
    text-decoration: none;
    font-size: 18px;
    font-weight: 600;
}
.brand-icon {
    width: 32px;
    height: 32px;
    background: rgba(255, 255, 255, 0.12);
    backdrop-filter: blur(4px);
    border-radius: 8px;
    padding: 4px;
    box-sizing: border-box;
}
.characters-wrap {
    height: 500px;
    display: flex;
    align-items: flex-end;
    justify-content: center;
}
.left-links {
    display: flex;
    gap: 30px;
}
.left-links a {
    font-size: 14px;
    color: #e5e7eb;
    text-decoration: none;
    transition: color 0.2s;
}
.left-links a:hover {
    color: #fff;
}
.grid-mask {
    position: absolute;
    inset: 0;
    z-index: 1;
    background-image:
        linear-gradient(to right, rgba(255, 255, 255, 0.08) 1px, transparent 1px),
        linear-gradient(to bottom, rgba(255, 255, 255, 0.08) 1px, transparent 1px);
    background-size: 20px 20px;
}
.glow {
    position: absolute;
    border-radius: 999px;
    filter: blur(48px);
    z-index: 1;
}
.glow-top {
    top: 25%;
    right: 25%;
    width: 260px;
    height: 260px;
    background: rgba(156, 163, 175, 0.32);
}
.glow-bottom {
    bottom: 20%;
    left: 20%;
    width: 380px;
    height: 380px;
    background: rgba(209, 213, 219, 0.28);
}
.right-panel {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 38px 32px;
    background: rgba(255, 255, 255, 0.96);
}
.form-box {
    width: 100%;
    max-width: 420px;
}
.mobile-brand {
    display: none;
    align-items: center;
    justify-content: center;
    gap: 8px;
    font-size: 18px;
    font-weight: 600;
    margin-bottom: 48px;
}
.mobile-icon {
    background: rgba(17, 24, 39, 0.06);
}
.form-head {
    text-align: center;
    margin-bottom: 40px;
}
.form-head h1 {
    margin: 0 0 8px;
    font-size: 34px;
    line-height: 1.2;
    font-weight: 700;
    letter-spacing: -0.01em;
    color: #111827;
}
.form-head p {
    margin: 0;
    font-size: 14px;
    color: #6b7280;
}
.login-wrap {
    margin-top: 0;
}
.form-item {
    margin-bottom: 16px;
}
.account-wrap {
    position: relative;
}
.input-label {
    display: inline-block;
    margin-bottom: 8px;
    font-size: 14px;
    font-weight: 500;
    color: #111827;
}
::v-deep .el-input__inner {
    height: 48px;
    line-height: 48px;
    border-radius: 10px;
    border: 1px solid rgba(107, 114, 128, 0.28);
    background: #fff;
}
::v-deep .el-input__inner:focus {
    border-color: #3b82f6;
}
::v-deep .el-input__suffix {
    right: 10px;
}
.password-toggle {
    cursor: pointer;
    color: #9ca3af;
    font-size: 16px;
    line-height: 48px;
}
.option-line {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 6px;
    margin-bottom: 16px;
}
::v-deep .el-checkbox__label {
    color: #374151;
    font-size: 14px;
}
.option-line .el-link {
    font-size: 14px;
    font-weight: 500;
}
.hover-btn {
    width: 100%;
    height: 48px;
    border-radius: 999px;
    border: 1px solid rgba(107, 114, 128, 0.28);
    background: #fff;
    position: relative;
    overflow: hidden;
    font-size: 16px;
    font-weight: 600;
    cursor: pointer;
    margin-top: 12px;
}
.btn-text {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    transition: all 0.3s;
}
.btn-overlay {
    position: absolute;
    inset: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    border-radius: 999px;
    opacity: 0;
    transition: all 0.3s;
}
.hover-btn:hover .btn-text {
    transform: translateX(48px);
    opacity: 0;
}
.hover-btn:hover .btn-overlay {
    opacity: 1;
}
.btn-primary {
    margin-top: 0;
    border: 1px solid #111827;
    background: #111827;
    color: #fff;
}
.btn-primary .btn-overlay {
    background: #1f2937;
    color: #fff;
}
.btn-outline {
    color: #111827;
}
.btn-outline .btn-overlay {
    background: #2563eb;
    color: #fff;
}
.google-icon {
    width: 18px;
    height: 18px;
}
.signup-tip {
    margin: 32px 0 0;
    text-align: center;
    font-size: 14px;
    color: #6b7280;
}
.signup-tip span {
    color: #111827;
    font-weight: 500;
}
.showRememberAccount {
    position: absolute;
    top: 78px;
    left: 0;
    box-sizing: border-box;
    width: 100%;
    background: #fff;
    border: 1px solid #d1d5db;
    border-radius: 10px;
    z-index: 20;
    box-shadow: 0 16px 32px rgba(17, 24, 39, 0.12);
}
::v-deep .el-dialog {
    border-radius: 12px;
}
@media (max-width: 1200px) {
    .career-login {
        padding: 16px;
    }

    .center-stage {
        height: calc(100vh - 32px);
        max-height: 760px;
    }

    .left-panel {
        padding: 32px;
    }

    .characters-wrap {
        transform: scale(0.9);
        transform-origin: center bottom;
    }
}

@media (max-width: 1024px) {
    .center-stage {
        width: 100%;
        max-width: 520px;
        height: auto;
        max-height: none;
    }

    .login-shell {
        grid-template-columns: 1fr;
    }

    .left-panel {
        display: none;
    }

    .mobile-brand {
        display: inline-flex;
    }

    .right-panel {
        padding: 24px;
        background: rgba(255, 255, 255, 0.98);
    }
}

@media (max-width: 520px) {
    .career-login {
        padding: 0;
    }

    .center-stage {
        border-radius: 0;
        height: 100vh;
    }

    .right-panel {
        padding: 16px;
    }

    .form-head h1 {
        font-size: 30px;
    }
}
</style>





